webpackJsonp([108160849931713],{

/***/ 2037:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"StripePaymentTypeResult","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"paymentIntentId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"String","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"type","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"ENUM","name":"StripePaymentType","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-stripe-payment-type-result-3bef420692f3d281d880.js